/* eslint-disable react/jsx-no-useless-fragment */
import Loader from '@components/Loader/Loader';
import { SxProps, Theme, Typography } from '@mui/material';
import { FULL_WIDTH_ROUTES } from 'constants/routes';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { IProps } from 'types/common';

interface IAppHeaderProps extends IProps {
	translation?: string;
	label?: string;
	values?: object;
	loading?: boolean;
	sx?: SxProps<Theme>;
	mb?: number;
}

const AppHeader: FC<IAppHeaderProps> = ({
	children,
	translation,
	label,
	values,
	loading,
	sx,
	mb
}) => {
	const headerTitle = translation ? intl.tr(translation, values) : '';
	const { pathname } = useLocation();
	const fullWith = FULL_WIDTH_ROUTES.some((route) => pathname.includes(route));

	return (
		<Typography
			variant="h6"
			data-testid="app-header-text"
			whiteSpace="nowrap"
			textOverflow="ellipsis"
			overflow="hidden"
			maxWidth="100%"
			mt={2}
			mb={mb}
			px={{
				xs: fullWith ? 1 : 0,
				sm: fullWith ? 2 : 0,
				md: fullWith ? 4 : 0
			}}
			minHeight={35}
			sx={sx}
		>
			<Loader variant="header" isLoading={!!loading}>
				<>
					{label || headerTitle}
					{children}
				</>
			</Loader>
		</Typography>
	);
};

AppHeader.defaultProps = {
	values: {},
	sx: {},
	mb: 2,
	translation: '',
	label: '',
	loading: false
};

export default AppHeader;
